import { RootState } from '../../../../redux/store';
import { SavedPersona } from '../../../chat/models/SavedPersona';
import { selectChatPersonalizationState } from './selectChatPersonalizationState';

export const selectSavedPersonas = (state: RootState): SavedPersona[] => {
    return selectChatPersonalizationState(state).personas;
};
